<template>
	<div class="home">
		<div class="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>通讯数据</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="search" style="background-color: #fff;">
			<vs-row>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">查询条件：</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="m-4 p-d flex">
					<el-date-picker
						style="width:100%"
						v-model="yearmonth"
						format="yyyy-MM"
						value-format="yyyy-MM"
						placeholder="选择月份"
						type="month">
					</el-date-picker>
				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
					<el-cascader style="width:360px" v-model="deptid" :options="options"
					             :props="{ checkStrictly: true,value:'id',label:'name'}" class="ml-4"></el-cascader>
				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
					<vs-button color="primary" type="filled" style="width:60%;margin-right: 20px;" @click="search">
						搜索
					</vs-button>
					<vs-button color="success" type="filled" style="width:80%" @click="handle_export">导出表格
					</vs-button>
				</vs-col>
			</vs-row>
		</div>
		<div class="tabs">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="数据总览" name="first">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: center;justify-content: space-around;">
							<div class="vx-col w-full md:w-5/5  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									分段环状图：</p>
								<vue-apex-charts type=donut height=345 ref="pieone" class="mt-2"
								                 :options="analyticsData.sessionsByDeviceDonut.chartOptions"
								                 :series="analyticsData.sessionsByDeviceDonut.series"/>
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData"
									    :key="customerData.customerType"
									    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
											<span class="flex items-center">
												<span class="inline-block h-3 w-3 rounded-full mr-2"
												      :class="`bg-${customerData.color}`"></span>
												<span class="font-semibold">{{ customerData.customerType }}</span>
											</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul>
							</div>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">考核分段：</p>
							<el-table
								id="table1"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								:data="onetable1"
								border
								style="width: 100%">
								<el-table-column label="企业文化考核情况" align="center">
									<el-table-column
										align="center"
										label="类别"
										width="120"
										prop="category">
									</el-table-column>
									<el-table-column
										align="center"
										label="考核人数"
										width="100"
										prop="numberOfPeople">
									</el-table-column>
									<el-table-column
										align="center"
										label="平均分"
										width="100"
										prop="theAverageScore">
									</el-table-column>
									<el-table-column label="80分以下" align="center">
										<el-table-column
											align="center"
											prop="scoreData[0].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[0].proportion"
											label="占比">
										</el-table-column>
									</el-table-column>
									<el-table-column label="80-90分" align="center">
										<el-table-column
											align="center"
											prop="scoreData[1].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[1].proportion"
											label="占比">
										</el-table-column>
									</el-table-column>
									<el-table-column label="90-100分" align="center">
										<el-table-column
											align="center"
											prop="scoreData[2].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[2].proportion"
											label="占比">
										</el-table-column>
									</el-table-column>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base" style="width: 80vw;overflow-x: auto;overflow-y: hidden;">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>总体平均分排名柱状图</span></span>
							</div>
							<vue-apex-charts type=bar :width="tableData.length*80" height=277 ref="barone1"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">总览分析：</p>
							<template>
								<el-table
									id="table0"
									:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
									:cell-style="TableRowStyle"
									v-if="allData.length>0"
									:span-method="arraySpanMethod"
									:data="allData"
									size="mini"
									border
									style="width: 100%">
									<el-table-column
										fixed="left"
										align="center"
										label="序号"
										width="50">
										<template slot-scope="scope">
											<p> {{ (scope.$index + 1) - (scope.$index / 3 * 2) }}</p>
										</template>
									</el-table-column>
									<el-table-column
										fixed="left"
										align="center"
										label="部门"
										width="150">
										<template slot-scope="scope">
											<p>{{ scope.row.deptName }}</p>
										</template>
									</el-table-column>
									<el-table-column
										fixed="left"
										align="center"
										label="姓名"
										width="100">
										<template slot-scope="scope">
											<p>{{ scope.row.name }}</p>
										</template>
									</el-table-column>
									<el-table-column label="顾客至上" align="center">
										<el-table-column
											align="center"
											prop="behaviors[0].finalScore"
											label="1.了解顾客需求"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[1].finalScore"
											label="2.及时满足顾客需求"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[2].finalScore"
											label="3.请顾客提意见">
											<template slot-scope="scope">
												<p v-if="scope.$index%3==0">{{ scope.row.behaviors[2].finalScore }}</p>
												<p v-else-if="scope.$index%3==1">
													{{ scope.row.dimension[0].totalScore }}</p>
												<p v-else>{{ scope.row.dimension[0].percentage }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[3].finalScore"
											label="4.坚持提供个性化服务">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[4].finalScore"
											label="5.契约精神">
										</el-table-column>
									</el-table-column>
									<el-table-column label="团队精神" align="center">
										<el-table-column
											align="center"
											prop="behaviors[5].finalScore"
											label="6.以组织利益为重"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[6].finalScore"
											label="7.敢于担当"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[7].finalScore"
											label="8.团队决策">
											<template slot-scope="scope">
												<p v-if="scope.$index%3==0">{{ scope.row.behaviors[7].finalScore }}</p>
												<p v-else-if="scope.$index%3==1">
													{{ scope.row.dimension[1].totalScore }}</p>
												<p v-else>{{ scope.row.dimension[1].percentage }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[8].finalScore"
											label="9.主动帮助团队成员">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[9].finalScore"
											label="10.积极参加团队活动">
										</el-table-column>
									</el-table-column>
									<el-table-column label="追求卓越" align="center">
										<el-table-column
											align="center"
											prop="behaviors[10].finalScore"
											label="11.坚持批判与自我批判"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[11].finalScore"
											label="12.勇于创新"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[12].finalScore"
											label="13.敢于挑战">
											<template slot-scope="scope">
												<p v-if="scope.$index%3==0">{{ scope.row.behaviors[12].finalScore }}</p>
												<p v-else-if="scope.$index%3==1">
													{{ scope.row.dimension[2].totalScore }}</p>
												<p v-else>{{ scope.row.dimension[2].percentage }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[13].finalScore"
											label="14.长期宣传企业文化">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[14].finalScore"
											label="15.自我挑战">
										</el-table-column>
									</el-table-column>
									<el-table-column label="长期坚持艰苦奋斗" align="center">
										<el-table-column
											align="center"
											prop="behaviors[15].finalScore"
											label="16.主动到异地工作"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[6].finalScore"
											label="17.主动承担新的工作"
											width="180">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[17].finalScore"
											label="18.主动加班">
											<template slot-scope="scope">
												<p v-if="scope.$index%3==0">{{ scope.row.behaviors[17].finalScore }}</p>
												<p v-else-if="scope.$index%3==1">
													{{ scope.row.dimension[3].totalScore }}</p>
												<p v-else>{{ scope.row.dimension[3].percentage }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[18].finalScore"
											label="19.主动到艰苦环境工作">
										</el-table-column>
										<el-table-column
											align="center"
											prop="behaviors[19].finalScore"
											label="20.主动取消法定假日">
										</el-table-column>
									</el-table-column>
									<el-table-column
										fixed="right"
										align="center"
										prop="total"
										label="合计"
										width="100">
									</el-table-column>
								</el-table>
							</template>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="四大分类" name="second">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: center;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									四大项展示(总体)：</p>
								<vue-apex-charts type=bar height=345 ref="pietwo"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
								<!-- <vue-apex-charts type=donut height=345   ref="pietwo" class="mt-2" :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="analyticsData.sessionsByDeviceDonut.series" />
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul> -->
							</div>
							<div class="vx-col w-full md:w-1/2  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									两级分化表：</p>
								<el-table
									id="table2"
									:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
									border
									:data="secendtable1"
									style="width: 100%">
									<el-table-column
										prop="dimension"
										label="类别"
										width="180">
									</el-table-column>
									<el-table-column
										prop="thisAverageScore"
										label="平均得分">
									</el-table-column>
									<el-table-column
										prop="thisMaxScore"
										label="最高得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMaxScore">
												{{ scope.row.thisMaxScore }}({{ scope.row.thisMaxScoreCount }})</p>
										</template>
									</el-table-column>
									<el-table-column
										prop="thisMinScoreCount"
										label="最低得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMinScore">
												{{ scope.row.thisMinScore }}({{ scope.row.thisMinScoreCount }})</p>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: center;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									四大项展示(分总)：</p>
								<vue-apex-charts type=bar height=345 ref="piethree"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
								<!-- <vue-apex-charts type=donut height=345   ref="piethree" class="mt-2" :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="analyticsData.sessionsByDeviceDonut.series" />
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul> -->
							</div>
							<div class="vx-col w-full md:w-1/2  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									两级分化表：</p>
								<el-table
									id="table3"
									:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
									border
									:data="secendtable2"
									style="width: 100%">
									<el-table-column
										prop="dimension"
										label="类别"
										width="180">
									</el-table-column>
									<el-table-column
										prop="thisAverageScore"
										label="平均得分">
									</el-table-column>
									<el-table-column
										prop="thisMaxScore"
										label="最高得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMaxScore">
												{{ scope.row.thisMaxScore }}({{ scope.row.thisMaxScoreCount }})</p>
										</template>
									</el-table-column>
									<el-table-column
										prop="thisMinScoreCount"
										label="最低得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMinScore">
												{{ scope.row.thisMinScore }}({{ scope.row.thisMinScoreCount }})</p>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: center;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									四大项展示(公司后勤)：</p>
								<vue-apex-charts type=bar height=345 ref="piethous"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
								<!-- <vue-apex-charts type=donut height=345   ref="piethous" class="mt-2" :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="analyticsData.sessionsByDeviceDonut.series" />
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul> -->
							</div>
							<div class="vx-col w-full md:w-1/2  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									两级分化表：</p>
								<el-table
									id="table4"
									:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
									border
									:data="secendtable3"
									style="width: 100%">
									<el-table-column
										prop="dimension"
										label="类别"
										width="180">
									</el-table-column>
									<el-table-column
										prop="thisAverageScore"
										label="平均得分">
									</el-table-column>
									<el-table-column
										prop="thisMaxScore"
										label="最高得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMaxScore">
												{{ scope.row.thisMaxScore }}({{ scope.row.thisMaxScoreCount }})</p>
										</template>
									</el-table-column>
									<el-table-column
										prop="thisMinScoreCount"
										label="最低得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMinScore">
												{{ scope.row.thisMinScore }}({{ scope.row.thisMinScoreCount }})</p>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: center;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									四大项展示(店长和分公司后勤)：</p>
								<vue-apex-charts type=bar height=345 ref="piefive"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
								<!-- <vue-apex-charts type=donut height=345   ref="piefive" class="mt-2" :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="analyticsData.sessionsByDeviceDonut.series" />
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul> -->
							</div>
							<div class="vx-col w-full md:w-1/2  mb-base">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									两级分化表：</p>
								<el-table
									id="table5"
									:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
									border
									:data="secendtable4"
									style="width: 100%">
									<el-table-column
										prop="dimension"
										label="类别"
										width="180">
									</el-table-column>
									<el-table-column
										prop="thisAverageScore"
										label="平均得分">
									</el-table-column>
									<el-table-column
										prop="thisMaxScore"
										label="最高得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMaxScore">
												{{ scope.row.thisMaxScore }}({{ scope.row.thisMaxScoreCount }})</p>
										</template>
									</el-table-column>
									<el-table-column
										prop="thisMinScoreCount"
										label="最低得分">
										<template slot-scope="scope">
											<p v-if="scope.row.thisMinScore">
												{{ scope.row.thisMinScore }}({{ scope.row.thisMinScoreCount }})</p>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="vx-col w-full  mb-base">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>四大项对比展示柱状图（分公司VS公司后勤部门）</span></span>
							</div>
							<vue-apex-charts type=bar height=277 ref="bartwo"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
						<div class="vx-col w-full  mb-base">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>四大项对比展示柱状图（分总 VS 公司后勤人员 VS  店长及分公司后勤）</span></span>
							</div>
							<vue-apex-charts type=bar height=277 ref="barthree"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="271分布" name="third">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								分总企业文化考核271排名：</p>
							<el-table
								height="600"
								id="table6"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="thirdtable2"
								style="width: 100%">
								<el-table-column
									type="index"
									align="center"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									prop="deptName"
									align="center"
									label="分店/分公司"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="positionName"
									label="职位">
								</el-table-column>
								<el-table-column
									align="center"
									prop="name"
									label="姓名">
								</el-table-column>
								<el-table-column
									prop="finalScore"
									align="center"
									label="最终得分">
									<template slot-scope="scope">
										<p v-if="scope.$index<Math.round(thirdtable2.length*0.2)" style="color: red;">
											{{ scope.row.finalScore }}</p>
										<p v-else-if="scope.$index>=Math.round(thirdtable2.length*0.9)"
										   style="color: blue;">{{ scope.row.finalScore }}</p>
										<p v-else>{{ scope.row.finalScore }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								后勤全体员工企业文化考核271排名：</p>
							<el-table
								id="table7"
								height="600"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="thirdtable3"
								style="width: 100%">
								<el-table-column
									type="index"
									align="center"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									prop="deptName"
									align="center"
									label="部门"
									width="180">
								</el-table-column>
								<el-table-column
									prop="positionName"
									align="center"
									label="职位">
								</el-table-column>
								<el-table-column
									prop="name"
									align="center"
									label="姓名">
								</el-table-column>
								<el-table-column
									prop="finalScore"
									label="最终得分">
									<template slot-scope="scope">
										<p v-if="scope.$index<Math.round(thirdtable3.length*0.2)" style="color: red;">
											{{ scope.row.finalScore }}</p>
										<p v-else-if="scope.$index>=Math.round(thirdtable3.length*0.9)"
										   style="color: blue;">{{ scope.row.finalScore }}</p>
										<p v-else>{{ scope.row.finalScore }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								店长及分公司后勤271排名：</p>
							<el-table
								id="table8"
								height="600"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="thirdtable4"
								style="width: 100%">
								<el-table-column
									align="center"
									type="index"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="deptName"
									label="部门"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="positionName"
									label="职位">
								</el-table-column>
								<el-table-column
									align="center"
									prop="name"
									label="姓名">
								</el-table-column>
								<el-table-column
									align="center"
									prop="finalScore"
									label="最终得分">
									<template slot-scope="scope">
										<p v-if="scope.$index<Math.round(thirdtable4.length*0.2)" style="color: red;">
											{{ scope.row.finalScore }}</p>
										<p v-else-if="scope.$index>=Math.round(thirdtable4.length*0.9)"
										   style="color: blue;">{{ scope.row.finalScore }}</p>
										<p v-else>{{ scope.row.finalScore }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>

					</div>
				</el-tab-pane>
				<el-tab-pane label="结果分析" name="fourth">
					<div class="vx-col w-full  mb-base flex"
					     style="align-items: flex-end;justify-content: space-around;">
						<div class="vx-col w-full   mb-base">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>近三月平均分柱状图总览</span></span>
							</div>
							<vue-apex-charts type=bar height=277 ref="barfours"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
					</div>
					<div class="vx-col w-full  mb-base">
						<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
							近三月考核人数和平均分总览：</p>
						<el-table
							id="table9"
							:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
							border
							:data="table"
							style="width: 100%">
							<el-table-column
								prop="positionName"
								label="团队"
								width="180">
							</el-table-column>
							<el-table-column label="实际参与企业文化考核人数" align="center">
								<el-table-column
									prop="numberOfPreviousMonths"
									label="上上月">
								</el-table-column>
								<el-table-column
									prop="numberOfPeopleLastMonth"
									label="上月">
								</el-table-column>
								<el-table-column
									prop="numberOfPeopleThisMonth"
									label="本月">
								</el-table-column>
							</el-table-column>
							<el-table-column label="企业文化平均得分" align="center">
								<el-table-column
									prop="averageScoreOfPreviousMonth"
									label="上上月">
								</el-table-column>
								<el-table-column
									prop="averageScoreLastMonth"
									label="上月">
								</el-table-column>
								<el-table-column
									prop="averageScoreThisMonth"
									label="本月">
								</el-table-column>
							</el-table-column>
						</el-table>
					</div>
					<div class="vx-col w-full  mb-base">
						<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">20项指标总览：</p>
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table10"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="thoused"
								style="width: 100%">
								<el-table-column
									prop="behaviors"
									label="指标项"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonthAverageScore"
									label="上月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonthAverageScore"
									label="本月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									:sortable="true"
									:sort-method="sortBythisMonth"
									label="本月总得分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									:sortable="true"
									:sort-method="sortByfirstMonth"
									label="增长值(%)">
									<template slot-scope="scope">
										<p v-if="scope.row.growthValue>=0" style="color:red">{{ scope.row.growthValue }}<i
											class="el-icon-top"></i></p>
										<p v-if="scope.row.growthValue<0" style="color:green">
											{{ scope.row.growthValue }}<i class="el-icon-bottom"></i></p>
									</template>
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";

import analyticsData from './ui-elements/card/analyticsData.js'
import VueApexCharts from 'vue-apexcharts'

export default {
	data() {
		return {
			analyticsData: analyticsData,
			activeName: "first",
			table: [],
			allData: [],   //总览分析
			tableData: [],
			onetable1: [],
			secendtable1: [],
			secendtable2: [],
			secendtable3: [],
			secendtable4: [],
			thirdtable1: [],
			thirdtable2: [],
			thirdtable3: [],
			thirdtable4: [],
			thoused: [],
			five: [],
			yearmonth: '',   //月份
			deptid: [],      //部门
			options: [],     //部门列表
		}
	},
	created() {
		this.yearmonth = this.getNowFormatDate();
	},
	mounted() {
		this.getall();
		this.getoptions();
	},

	components: {
		VueApexCharts,
	},
	methods: {
		// 导出
		handle_export() {
			let table = document.querySelector("#table0").cloneNode(true);
			console.log('表格', table);
			table.removeChild(table.querySelector(".el-table__fixed-right"));
			table.removeChild(table.querySelector(".el-table__fixed"));
			console.log('表格', table);

			var xlsxParam = {
				raw: true
			}; //转换成excel时，使用原始的格式，这样导出的时候数字过长不会变成科学计数法
			let workbook = XLSX.utils.book_new();
			// let ws0 = XLSX.utils.table_to_sheet(document.querySelector('#table0'), xlsxParam);
			// XLSX.utils.book_append_sheet(workbook, ws0, '达成情况分析');
			let ws0 = XLSX.utils.table_to_sheet(table, xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws0, '总览分析');
			let ws1 = XLSX.utils.table_to_sheet(document.querySelector('#table1'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws1, '考核分段');
			let ws2 = XLSX.utils.table_to_sheet(document.querySelector('#table2'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws2, '四大项展示(总体)');
			let ws3 = XLSX.utils.table_to_sheet(document.querySelector('#table3'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws3, '四大项展示(分总)');
			let ws4 = XLSX.utils.table_to_sheet(document.querySelector('#table4'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws4, '四大项展示(公司后勤)');
			let ws5 = XLSX.utils.table_to_sheet(document.querySelector('#table5'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws5, '四大项展示(店长和分公司后勤)');
			let ws6 = XLSX.utils.table_to_sheet(document.querySelector('#table6'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws6, '分总企业文化考核271排名');
			let ws7 = XLSX.utils.table_to_sheet(document.querySelector('#table7'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws7, '后勤全体员工企业文化考核271排名');
			let ws8 = XLSX.utils.table_to_sheet(document.querySelector('#table8'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws8, '店长及分公司后勤271排名');

			let ws9 = XLSX.utils.table_to_sheet(document.querySelector('#table9'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws9, '近三月考核人数和平均分总览');
			let ws10 = XLSX.utils.table_to_sheet(document.querySelector('#table10'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws10, '20项指标总览');

			let wbout = XLSX.write(workbook, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: 'application/octet-stream;charset=utf-8"'
					}), '统计分析.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') console.log(e);
			}
			return wbout;
		},
		//定义导出Excel表格事件
		exportExcel() {
			var xlsxParam = {raw: true};
			/* 从表生成工作簿对象 */
			var wb = XLSX.utils.table_to_book(
				document.querySelector("#outtable"),
				xlsxParam
			);
			/* 获取二进制字符串作为输出 */
			var wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});
			try {
				FileSaver.saveAs(
					//Blob 对象表示一个不可变、原始数据的类文件对象。
					//Blob 表示的不一定是JavaScript原生格式的数据。
					//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
					//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
					new Blob([wbout], {type: "application/octet-stream"}),
					//设置导出文件名称
					"sheetjs.xlsx"
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}
			return wbout;
		},
		/**
		 * 获取上一个月
		 * @date 格式为yyyy-mm-dd的日期，如：2014-01
		 */
		getPreMonth(date) {
			var arr = date.split('-');
			var year = arr[0]; //获取当前日期的年份
			var month = arr[1]; //获取当前日期的月份
			var days = new Date(year, month, 0);
			days = days.getDate(); //获取当前日期中月的天数
			var year2 = year;
			var month2 = parseInt(month) - 1;
			if (month2 == 0) {
				year2 = parseInt(year2) - 1;
				month2 = 12;
			}
			if (month2 < 10) {
				month2 = '0' + month2;
			}
			var t2 = year2 + '-' + month2;
			return t2;
		},
		getoptions() {	//获取部门列表
			const that = this;
			this.$api.getmember({}).then(function (response) {
				console.log("组织架构：", response);
				if (response.code == 0) {
					that.data = JSON.parse(JSON.stringify(response.data));
					that.options = that.removeEmptyChildren(response.data);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		removeEmptyChildren(node) {   //杀生
			var that = this;
			node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
			})
			return node;
		},

		sortBythisMonth(obj1, obj2) {	//本月排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.thisMonth;
			let val2 = obj2.thisMonth;
			return val1 - val2

		},
		sortByfirstMonth(obj1, obj2) {	//增长值排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.growthValue;
			let val2 = obj2.growthValue;
			return val1 - val2

		},
		TableRowStyle({row, column, rowIndex, columnIndex}) {
			if (columnIndex != 0 && columnIndex != 1 && columnIndex != 23) {
				if (rowIndex % 3 == 0) {
					return {color: "red", fontSize: "18px"};
				} else if (rowIndex % 3 == 1) {
					return {color: "#5ECDF5", fontSize: "18px"};
				} else if (rowIndex % 3 == 2) {
					return {color: "#000000", fontSize: "18px"};
				}
			} else {
				return {color: "#000000", fontSize: "18px"};
			}
		},
		arraySpanMethod({row, column, rowIndex, columnIndex}) {  //合并行与列
			if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			} else if (columnIndex === 23) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			} else if (rowIndex % 3 === 1 || rowIndex % 3 === 2) {
				if (columnIndex % 5 === 0) {
					return {
						rowspan: 1,
						colspan: 5
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},


		handleClick() {
			console.log("切换了", this.activeName);
			if (this.activeName == "first") {
				this.getall()
			} else if (this.activeName == "second") {
				this.getsecend()
			} else if (this.activeName == "third") {
				this.getthird()
			} else if (this.activeName == "fourth") {
				this.getthoused()
			}
		},
		search() {
			if (this.activeName == "first") {
				this.getall()
			} else if (this.activeName == "second") {
				this.getsecend()
			} else if (this.activeName == "third") {
				this.getthird()
			} else if (this.activeName == "fourth") {
				this.getthoused()
			}
		},
		getthoused() {
			const that = this;
			this.$api.statisticsthoused({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					that.thoused = response.data;
					that.$api.reportavage({
						assessTime: that.yearmonth,
						deptId: that.deptid[that.deptid.length - 1]
					}).then(function (response) {
						console.log("平均分", response);
						that.table = response.data;
						let avage = [];
						let month = ['上上月', '上月', '本月'];
						response.data.forEach(item => {
							if (item.positionName == '合计') {
								avage = [item.averageScoreOfPreviousMonth, item.averageScoreLastMonth, item.averageScoreThisMonth];
							}
						})
						that.$refs.barfours.updateOptions({
							series: [{name: '平均分', data: avage}],
							xaxis: {categories: month}
						})
					})
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getthird() {     //271分
			const that = this;
			this.$api.reportarrange({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					console.log("271排名", response);
					that.thirdtable1 = response.data.all;   //全部
					that.thirdtable2 = response.data.totalScore;   //分总
					that.thirdtable3 = response.data.logistics;   //后勤
					that.thirdtable4 = response.data.storeManagerAndBranchLogistics;   //店长及分公司
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getsecend() {    //四大项
			const that = this;
			this.$api.reportteam({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					console.log("四大项", response.data)
					that.secendtable1 = response.data.all;
					that.secendtable2 = response.data.totalScore;
					that.secendtable3 = response.data.logistics;
					that.secendtable4 = response.data.storeManagerAndBranchLogistics;

					var allname = [];    //整体
					var totalScorename = []; //分总
					var logisticsname = [];  //后勤
					var storeManagerAndBranchLogisticsname = [];  //店长及分公司后勤

					var allnum = [];
					var totalScorenum = [];
					var logisticsnum = [];
					var storeManagerAndBranchLogisticsnum = [];


					response.data.all.forEach(item => {
						allname.push(item.dimension);
						allnum.push(Number(item.thisAverageScore));
					})
					response.data.totalScore.forEach(item => {
						totalScorename.push(item.dimension);
						totalScorenum.push(Number(item.thisAverageScore));
					})
					response.data.logistics.forEach(item => {
						logisticsname.push(item.dimension);
						logisticsnum.push(Number(item.thisAverageScore));
					})
					response.data.storeManagerAndBranchLogistics.forEach(item => {
						storeManagerAndBranchLogisticsname.push(item.dimension);
						storeManagerAndBranchLogisticsnum.push(Number(item.thisAverageScore));
					})
					//环形图
					that.$refs.pietwo.updateOptions({
						series: [{name: '分数', data: allnum}],
						xaxis: {categories: allname}
					})
					that.$refs.piethree.updateOptions({
						series: [{name: '分数', data: totalScorenum}],
						xaxis: {categories: totalScorename}
					})
					that.$refs.piethous.updateOptions({
						series: [{name: '分数', data: logisticsnum}],
						xaxis: {categories: logisticsname}
					})
					that.$refs.piefive.updateOptions({
						series: [{name: '分数', data: storeManagerAndBranchLogisticsnum}],
						xaxis: {categories: storeManagerAndBranchLogisticsname}
					})

					var fen = [];
					var log = [];
					var tot = [];
					var sto = [];
					for (var i = 0; i < 4; i++) {
						fen[i] = (((Number(totalScorenum[i]) || 0) + (Number(storeManagerAndBranchLogisticsnum[i]) || 0)) / 2).toFixed(2);
						log[i] = Number(logisticsnum[i]) || 0;
						tot[i] = Number(totalScorenum[i]) || 0;
						sto[i] = Number(storeManagerAndBranchLogisticsnum[i]) || 0;
					}
					//柱状图
					that.$refs.bartwo.updateOptions({   //柱状图
						series: [{name: '分公司', data: fen}, {name: '公司后勤部门', data: log,}],
						xaxis: {categories: allname}
					})
					that.$refs.barthree.updateOptions({   //柱状图
						series: [{name: '分总', data: tot}, {
							name: '公司后勤部门',
							data: log
						}, {name: '店长及分公司后勤', data: sto}],
						xaxis: {categories: allname}
					})
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getall() {
			const that = this;
			//总览分析
			this.$api.statisticsfirst({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				console.log("提交结果：", response);
				if (response.code == 0) {
					that.allData = response.data;
					var arr = [];
					response.data.forEach(item => {
						// if(item.behaviors.length<20){
						//  console.log("111",item.name);
						// }

						var a = [item, item, item];
						arr.push.apply(arr, a);
					})
					that.allData = arr;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})

			this.$api.reportresults({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					console.log("数据总览", response);
					var allname = [];
					var allnum = [];
					that.tableData = response.data.all;
					response.data.all.forEach(item => {
						allname.push(item.name);
						allnum.push(item.score);
					})
					that.$refs.barone1.updateOptions({
						series: [{name: '分数', data: allnum}],
						xaxis: {categories: allname}
					})
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
			this.$api.reportcommuni({
				assessTime: that.yearmonth,
				deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					console.log("考核结果", response);
					if (response.data.aggregate && response.data.list) {
						that.onetable1 = response.data.list;
						var name = [];
						var num = [];
						response.data.aggregate.scoreData.forEach((item) => {
							name.push(item.name);
							// num.push(Number(item.proportion));
							num.push(item.numberOfPeople);
						})
						that.$refs.pieone.updateOptions({   //环形图
							series: num,
							labels: name
						})
					} else {
						that.onetable1 = [];
						that.$refs.pieone.updateOptions({   //环形图
							series: [],
							labels: []
						})
					}

				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getNowFormatDate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + seperator1 + month;
			var lastmonth = this.getPreMonth(currentdate)
			return lastmonth;
		},

	}
}
</script>
<style type="text/css">
.home .head {
	height: 50px;
	display: flex;
	align-items: center;
	background: #ffffff;
	padding: 20px;
}

.home .tabs {
	margin: 20px 30px;
	background: #ffffff;
	padding: 20px;
}

.home .el-table {
	border: 1px solid #000000 !important;
	border-left: 1px solid #000000 !important;
}

.home .el-table td,
.home .el-table th {
	border-bottom: 1px solid #000000 !important;
	border-right: 1px solid #000000 !important;
}
</style>
